(function(){
  'use strict';
  var TARGET_VARIANTS={'43147450581063':true,'43147449270343':true,'43147449532487':true};
  var TARGET_PATHS=['/products/build-your-own-box-2','/products/build-your-own-box-4','/products/build-your-own-box-6'];

  function rootPath(){
    return window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/';
  }
  function builderUrl(){
    return rootPath()+'pages/new-byob?selection=required';
  }
  function cleanId(v){
    var s=String(v==null?'':v);
    var m=s.match(/(\d+)$/);
    return m?m[1]:s;
  }
  function isTarget(id){
    return !!TARGET_VARIANTS[cleanId(id)];
  }
  function hasSelectionProps(props){
    if(!props)return false;
    return !!(props['_Cupcake Source']||props['_Cupcake Variant IDs']||props['Flavor Summary']);
  }
  function itemAllowed(item){
    if(!item||!isTarget(item.id||item.variant_id))return true;
    return hasSelectionProps(item.properties);
  }
  function payloadBlocked(data){
    if(!data)return false;
    if(Array.isArray(data.items))return data.items.some(function(item){return !itemAllowed(item);});
    if(isTarget(data.id||data.variant_id))return !hasSelectionProps(data.properties);
    return false;
  }
  function formDataBlocked(fd){
    if(!fd)return false;
    var id=fd.get('id')||fd.get('variant_id');
    if(!isTarget(id))return false;
    var has=false;
    fd.forEach(function(value,key){
      if(key==='properties[_Cupcake Source]'||key==='properties[_Cupcake Variant IDs]'||key==='properties[Flavor Summary]')has=true;
    });
    return !has;
  }
  function bodyBlocked(body){
    if(!body)return false;
    try{
      if(typeof FormData!=='undefined'&&body instanceof FormData)return formDataBlocked(body);
      if(typeof URLSearchParams!=='undefined'&&body instanceof URLSearchParams){
        var id=body.get('id')||body.get('variant_id');
        if(!isTarget(id))return false;
        return !(body.get('properties[_Cupcake Source]')||body.get('properties[_Cupcake Variant IDs]')||body.get('properties[Flavor Summary]'));
      }
      if(typeof body==='string'){
        var s=body.trim();
        if(!s)return false;
        if(s.charAt(0)==='{'||s.charAt(0)==='[')return payloadBlocked(JSON.parse(s));
        return bodyBlocked(new URLSearchParams(s));
      }
    }catch(e){}
    return false;
  }
  function routeToBuilder(){
    try{sessionStorage.setItem('st_byob_selection_required','1');}catch(e){}
    window.location.assign(builderUrl());
  }

  var path=(window.location.pathname||'').replace(/\/$/,'');
  if(TARGET_PATHS.indexOf(path)>=0){
    routeToBuilder();
    return;
  }

  document.addEventListener('submit',function(e){
    var form=e.target&&e.target.closest?e.target.closest('form[action*="/cart/add"]'):null;
    if(!form)return;
    try{
      if(formDataBlocked(new FormData(form))){
        e.preventDefault();
        e.stopImmediatePropagation();
        routeToBuilder();
      }
    }catch(err){}
  },true);

  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest?e.target.closest('a[href*="/cart/add"]'):null;
    if(!a)return;
    try{
      var u=new URL(a.href,window.location.origin);
      var id=u.searchParams.get('id')||u.searchParams.get('variant');
      if(isTarget(id)){
        e.preventDefault();
        e.stopImmediatePropagation();
        routeToBuilder();
      }
    }catch(err){}
  },true);

  if(window.fetch){
    var originalFetch=window.fetch;
    window.fetch=function(input,init){
      var url=typeof input==='string'?input:(input&&input.url)||'';
      if(/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)&&init&&bodyBlocked(init.body)){
        routeToBuilder();
        return Promise.reject(new Error('Cupcake selections are required before adding this box.'));
      }
      return originalFetch.apply(this,arguments);
    };
  }
})();